import type { SocialId } from '../config/socials';

export const socialQrPaths = {
  "x": "/qrcodes/x.svg",
  "telegram": "/qrcodes/telegram.svg",
  "wechat": "/qrcodes/wechat.png",
  "discord": "/qrcodes/discord.svg",
  "github": "/qrcodes/github.svg",
  "keybase": "/qrcodes/keybase.svg",
  "steam": "/qrcodes/steam.svg"
} as const satisfies Record<SocialId, string>;
